import type { KeyboardEvent, MouseEvent } from "react";

import { createActivationKeyDownHandler } from "@Front/Utils/interactiveElementA11y";

export function createIconButtonKeyDownHandler(
	onClick: ((e: MouseEvent<HTMLSpanElement>) => void) | undefined,
): (e: KeyboardEvent<HTMLSpanElement>) => void {
	return createActivationKeyDownHandler<HTMLSpanElement>((e) => {
		onClick?.(e as unknown as MouseEvent<HTMLSpanElement>);
	});
}
